import { EventEmitter, } from '@evergis/event-emitter';
/**
 * https://github.com/dominictarr/hashlru#algorithm
 */
export class LruCache {
    constructor(maxSize = DEFAULT_SIZE) {
        this.maxSize = maxSize;
        this.cache = new Map();
        this.oldCache = new Map();
        this.emitter = new EventEmitter();
    }
    push(key, value) {
        if (this.size >= this.maxSize) {
            this.oldCache.clear();
            this.oldCache = this.cache;
            this.cache = new Map();
        }
        this.cache.set(key, value);
    }
    set(key, value) {
        if (this.cache.has(key)) {
            this.cache.set(key, value);
        }
        else {
            this.push(key, value);
        }
        this.emitter.emit('update', { key, value });
    }
    get(key) {
        if (this.cache.has(key)) {
            return this.cache.get(key);
        }
        if (this.oldCache.has(key)) {
            const value = this.oldCache.get(key);
            this.oldCache.delete(key);
            this.set(key, value);
            return value;
        }
        return;
    }
    delete(key) {
        const deleted = this.cache.delete(key) || this.oldCache.delete(key);
        if (deleted) {
            this.emitter.emit('delete', { key });
        }
        return deleted;
    }
    clear() {
        this.cache.clear();
        this.oldCache.clear();
        this.emitter.emit('clear');
    }
    entries() {
        const cacheEntries = Array.from(this.cache.entries());
        const oldCacheEntries = Array.from(this.oldCache.entries());
        return cacheEntries.concat(oldCacheEntries);
    }
    on(event, callback) {
        this.emitter.on(event, callback);
    }
    off(event, callback) {
        this.emitter.off(event, callback);
    }
    get size() {
        return this.cache.size;
    }
}
const DEFAULT_SIZE = 10;
//# sourceMappingURL=lru-cache.js.map